// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import AuthProvider from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { NotificationProvider } from './context/NotificationContext';
import { ToastProvider } from './components/Notifications/ToastContainer';
import FacilityProvider from './context/FacilityContext';
import './index.css';
import './styles/tokens/z-index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/brand-overrides.css';
import './styles/ff-alert-overrides.css';

// ---------------------------------------------------------------------------
// Boot telemetry — capture uncaught errors that could leave the app stuck.
// console.warn/error survive terser stripping in production builds.
// ---------------------------------------------------------------------------
window.addEventListener('error', (evt) => {
  console.error('[BOOT_ERROR]', evt.message, evt.filename, evt.lineno, evt.colno);
});
window.addEventListener('unhandledrejection', (evt) => {
  console.error('[BOOT_UNHANDLED_REJECTION]', evt.reason);
});

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!googleClientId) {
  throw new Error('Missing REACT_APP_GOOGLE_CLIENT_ID in .env');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <NotificationProvider> {/* 🟡 MUST be outermost */}
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <CartProvider>
                <FacilityProvider>
                  <App />
                </FacilityProvider>
              </CartProvider>
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </NotificationProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
